import type { CSSProperties } from "react";
import type { AdventureContent } from "../types/adventure";

interface AdventureSelectProps {
  adventures: AdventureContent[];
  isPaid: boolean;
  onSelect: (id: string) => void;
  onLocked: (label: string) => void;
}

export function AdventureSelect({
  adventures,
  isPaid,
  onSelect,
  onLocked,
}: AdventureSelectProps) {
  return (
    <section className="act-select jari-card">
      <h2>Kies je avontuur</h2>
      <p className="act-select__intro">
        Ga op avontuur en leer omgaan met je gedachten. Kies een verhaal om te
        beginnen.
      </p>
      <div className="act-select__grid">
        {adventures.map((adv) => {
          const locked = !adv.free && !isPaid;
          return (
            <button
              key={adv.id}
              type="button"
              className={`act-adventure-card${locked ? " act-adventure-card--locked" : ""}`}
              style={adv.theme as CSSProperties}
              onClick={() => {
                if (locked) {
                  onLocked(adv.label);
                  return;
                }
                onSelect(adv.id);
              }}
            >
              <span className="act-adventure-card__goal" aria-hidden>
                {adv.goal.icon}
              </span>
              <span className="act-adventure-card__title">{adv.label}</span>
              <span className="act-adventure-card__tagline">{adv.tagline}</span>
              {locked && (
                <span className="act-adventure-card__lock" aria-hidden>
                  🔒 Licentie
                </span>
              )}
              {adv.free && (
                <span className="act-adventure-card__badge">Gratis</span>
              )}
            </button>
          );
        })}
      </div>
    </section>
  );
}
